<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.66667 18.9577C3.625 18.9577 1.875 17.2077 1.875 14.166V5.83268C1.875 2.79102 3.625 1.04102 6.66667 1.04102H13.3333C16.375 1.04102 18.125 2.79102 18.125 5.83268V14.166C18.125 17.2077 16.375 18.9577 13.3333 18.9577H6.66667ZM3.125 5.83268V14.166C3.125 16.5493 4.28333 17.7077 6.66667 17.7077H13.3333C15.7167 17.7077 16.875 16.5493 16.875 14.166V5.83268C16.875 3.44935 15.7167 2.29102 13.3333 2.29102H6.66667C4.28333 2.29102 3.125 3.44935 3.125 5.83268Z"
      fill="CurrentColor"
    />
    <path
      d="M13.7497 7.70833C12.483 7.70833 11.458 6.68333 11.458 5.41667V3.75C11.458 3.40833 11.7413 3.125 12.083 3.125C12.4247 3.125 12.708 3.40833 12.708 3.75V5.41667C12.708 5.99167 13.1747 6.45833 13.7497 6.45833H15.4163C15.758 6.45833 16.0413 6.74167 16.0413 7.08333C16.0413 7.425 15.758 7.70833 15.4163 7.70833H13.7497Z"
      fill="CurrentColor"
    />
    <path
      d="M6.66699 11.458C6.32533 11.458 6.04199 11.1747 6.04199 10.833C6.04199 10.4913 6.32533 10.208 6.66699 10.208H10.0003C10.342 10.208 10.6253 10.4913 10.6253 10.833C10.6253 11.1747 10.342 11.458 10.0003 11.458H6.66699Z"
      fill="CurrentColor"
    />
    <path
      d="M6.66699 14.792C6.32533 14.792 6.04199 14.5087 6.04199 14.167C6.04199 13.8253 6.32533 13.542 6.66699 13.542H13.3337C13.6753 13.542 13.9587 13.8253 13.9587 14.167C13.9587 14.5087 13.6753 14.792 13.3337 14.792H6.66699Z"
      fill="CurrentColor"
    />
  </svg>
</template>
